export default "<div class=\"bookings\">\n  <ng-content></ng-content>\n</div>\n";